import { render } from "./ProfileTerms.vue?vue&type=template&id=83b3e9a4&scoped=true"
import script from "./ProfileTerms.vue?vue&type=script&lang=js"
export * from "./ProfileTerms.vue?vue&type=script&lang=js"

import "./ProfileTerms.vue?vue&type=style&index=0&id=83b3e9a4&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b3e9a4"]])

export default __exports__